import React, { useState, useRef, useEffect } from 'react';
import './SearchBar.css';

function SearchBar({ 
  selectorType, 
  setSelectorType, 
  selectorValue, 
  setSelectorValue, 
  onSearch,
  isSearching 
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const selectType = (type) => {
    setSelectorType(type);
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="search-bar-container">
      <form className={`search-bar ${selectorType === 'phone' ? 'coming-soon' : ''}`} onSubmit={handleSubmit}>
        <div className="selector-type-dropdown" ref={dropdownRef}>
          <button
            type="button"
            className="selector-button"
            onClick={toggleDropdown}
            disabled={isSearching}
          >
            {selectorType === 'email' ? (
              <i className="bi-envelope-at selector-icon"></i>
            ) : (
              <i className="bi-telephone selector-icon"></i>
            )}
            <span className="selector-text">
              {selectorType === 'email' ? 'Email' : 'Phone'}
            </span>
            <i className={`bi-chevron-down selector-chevron ${isDropdownOpen ? 'open' : ''}`}></i>
          </button>
          {isDropdownOpen && (
            <div className="selector-dropdown-menu">
              <button
                type="button"
                className={`selector-option ${selectorType === 'email' ? 'active' : ''}`}
                onClick={() => selectType('email')}
              >
                <i className="bi-envelope-at"></i>
                <span>Email</span>
              </button>
              <button
                type="button"
                className={`selector-option ${selectorType === 'phone' ? 'active' : ''}`}
                onClick={() => selectType('phone')}
              >
                <i className="bi-telephone"></i>
                <span>Phone</span>
              </button>
            </div>
          )}
        </div>
        
                <input
                  type="text"
                  className="search-input"
                  placeholder={
                    selectorType === 'email'
                      ? 'Enter email address...'
                      : 'Coming Soon'
                  }
                  value={selectorValue}
                  onChange={(e) => setSelectorValue(e.target.value)}
                  disabled={isSearching || selectorType === 'phone'}
                />

                <button
                  type="submit"
                  className="search-button-main"
                  disabled={isSearching || selectorType === 'phone'}
                >
          {isSearching ? (
            <span className="spinner"></span>
          ) : (
            <>
              <i className="bi-search"></i> Search
            </>
          )}
        </button>
      </form>
      
      <p className="search-hint">
        Enter an email or phone number to discover associated accounts
      </p>
    </div>
  );
}

export default SearchBar;

